import useRewardTableColumns from './useRewardTableColumns'

export default useRewardTableColumns
